import { sagaMiddleware } from '../../store';

import * as attachmentActions from './actions';
import * as attachmentsSelectors from './selectors';
import saga from './saga';
import * as attachmentsUtils from './utils';

import * as aiChatAttachmentActions from './ai-chat-attachments/actions.js';
import * as aiChatAttachmentSelectors from './ai-chat-attachments/selectors.js';
import aiChatAttachmentSaga from './ai-chat-attachments/saga.js';

export let actions = attachmentActions;
export let selectors = attachmentsSelectors;
export let utils = attachmentsUtils;

export const aichat = {
  actions: aiChatAttachmentActions,
  selectors: aiChatAttachmentSelectors,
};

sagaMiddleware.run(saga);
sagaMiddleware.run(aiChatAttachmentSaga);
